module.exports = __webpack_public_path__ + "77d90b624ee85f0e96ac7d85319b110d.svg";